import { RootState } from "../../store";

export const selectAnalytics = (state: RootState) => state.analytics;